module.exports = __webpack_public_path__ + "static/media/driehaus-award.6113e2cf.png";